export default function EclipProgress({ title, value=0 }) {
	return (
		<div className="eclip-progress">
			<div className="eclip-progress__title">{title}</div>
			<div className="eclip-progress__bar">
				<progress
					className="eclip-progress__bar__progress"
					value={value}
					max="100"
				></progress>
				<div className="eclip-progress__percentage">{value}%</div>
			</div>
		</div>
	)
}
